import React from 'react';
/**
 * ClientCarouselCard component displays an image carousel card within the client carousel.
 *
 * @component
 * @param {Object} props - The properties for the ClientCarouselCard component.
 * @returns {JSX.Element} The rendered ClientCarouselCard component.
 */
const ClientCarouselCard = (props) => (
  <div className='ClientLogoBox'>
    <img src={props.img} alt='Client Image' loading='lazy' />
  </div>
);

export default ClientCarouselCard;
